import TxtRender from './txt'
import { getFileExtension } from '@/utils/common'

export default function DocViewer({ src }: { src: string }) {
  const fileExtension = getFileExtension(src)

  if (fileExtension === 'md') {
    return <TxtRender fileUrl={src} />
  } else if (fileExtension === 'txt' || fileExtension === 'pdf') {
    // return <PdfRender url={src} />
    return (
      <iframe
        title="文档预览"
        id="_frontendAppCustomFrame_"
        src={src}
        allowFullScreen
        allow="microphone;camera;midi;encrypted-media;"
        className="w-full h-full fade-in"
        style={{ border: 0 }}
      ></iframe>
    )
  }

  return (
    <iframe
      title="文档预览"
      id="_frontendAppCustomFrame_"
      src={`https://view.officeapps.live.com/op/view.aspx?src=${encodeURIComponent(
        src,
      )}`}
      allowFullScreen
      allow="microphone;camera;midi;encrypted-media;"
      className="w-full h-full fade-in"
      style={{ border: 0 }}
    ></iframe>
  )
}
